import React from 'react';
import './Navigation.css';
import NavigationBar from './NavigationBar';
import NavigationBarIndicator from './NavigationBarIndicator';
import {useState} from 'react';




const Navigation = ({pageposition,setPagePosition,navigationItems,navnumber}) => {

    const [indicatorposition, setIndicatorPosition] = useState(1);
    const cn = 'Navigation'+navnumber;

    return (
        window.innerWidth < 1500 ? 
        <div className={cn}>
            <NavigationBar navNumber={navnumber} navigationItems={navigationItems}  setIndicatorPosition={setIndicatorPosition} setPagePosition = {setPagePosition}/>
        </div>
        : <div className= {cn}>
            <NavigationBar navNumber={navnumber} navigationItems={navigationItems}  setIndicatorPosition={setIndicatorPosition} setPagePosition = {setPagePosition}/>
            <NavigationBarIndicator navigationItems={navigationItems} pageposition = {pageposition} indicatorposition = {indicatorposition}/>
    </div>
    );


};


export default Navigation;